export const cellNestedRenderBox = 'cell-nested-render-box';
